import { Directive, HostListener, Input } from '@angular/core';
import { ExceptionsService } from '../../services/utelize/general/exceptions-service';

@Directive({ selector: '[appOnlyInteger]' })

export class OnlyIntegerDirective {

  @Input() appOnlyInteger: boolean | undefined;
  
  constructor(
    private exceptionsService: ExceptionsService
  ) {
    
  }

  private isControlKey(key: string) {
    try {
      return ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Home','End'].includes(key);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  @HostListener('keydown', ['$event'])
  public onKeydown(keyboardEvent: KeyboardEvent) {
    try {
      if (!this.appOnlyInteger)
        return;
      
      const banned=['.', ',', 'e', 'E', '+', '-', ' '];
      
      if (this.isControlKey(keyboardEvent.key))
        return;
      
      if (banned.includes(keyboardEvent.key))
        keyboardEvent.preventDefault();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  @HostListener('paste', ['$event'])
  public onPaste(clipboardEvent: ClipboardEvent) {
    try {
      if (!this.appOnlyInteger)
        return;
      
      const text=clipboardEvent.clipboardData?.getData('text') ?? '';
      
      if (!/^\d*$/.test(text))
        clipboardEvent.preventDefault();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  @HostListener('drop', ['$event'])
  public onDrop(dragEvent: DragEvent) {
    try {
      if (!this.appOnlyInteger)
        return;
      
      const text=dragEvent.dataTransfer?.getData('text') ?? '';
      
      if (!/^\d*$/.test(text)) {
        dragEvent.preventDefault();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
